<template>
  <v-dialog v-model="reportDataDialogArticle" fullscreen >
    <v-card style="background-color:#323232;">
      <!--Title and close button-->
      <v-toolbar style="background-color: #eee">
        <v-spacer></v-spacer>
        <p class="pt-6">
          <span class="title">av artikkel:</span>
          <!-- <span class="pl-2"><strong> {{item.ArticleTitle}}</strong></span> -->
        </p>
        <v-spacer></v-spacer>
        <v-btn color="error" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <!--Divide the dialog in 2 parts-->
      <v-row class="ma-0 pa-0" v-if="item">
        <v-col md="6">
          <!-- <p>More Information</p> -->
          <!--Report Information-->
          <v-row>
            <v-col>
              <v-card class="pa-3" style="background-color: #eee" outlined>
                <p class="text-center title pb-3 pt-3" style="color: white; font-size: 1.2em; font-weight: 700; letter-spacing: .2em; text-shadow: 2px 2px 10px #000, 2px 2px 20px #000, -2px -2px 20px #000, 2px -2px 20px #000, -2px 2px 20px #000;">Report Data</p>
                <v-row class="pl-2">
                  <v-col>
                    <!--Reason of the Report-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Reason :</span>
                      <span class="subtitle-1">{{ item.Reason }}</span>
                    </p>
                    <!--Reported by user-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Reported by user :</span>
                      <span class="subtitle-1">{{ item.ReportedBy }}</span>
                    </p>
                    <!--Report Created-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Created :</span>
                      <span class="subtitle-1">{{ item.Created | moment('LL') }}</span>
                    </p>
                  </v-col>
                  <v-col>
                    <!--Total Reports on this Article-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Total reports on this article :</span>
                      <span class="subtitle-1">{{ item.UserReportingTotal }}</span>
                    </p>
                    <!--Report Id-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Report id :</span>
                      <span class="subtitle-1">{{ item.id }}</span>
                    </p>
                    <!--Ip address-->
                    <!-- <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Client Ip :</span>
                      <span class="subtitle-1">{{ item.ClientIP }}</span>
                    </p> -->
                    <!--Client id-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Articles id :</span>
                      <span class="subtitle-1">{{ item.Articles_id }}</span>
                    </p>
                  </v-col>
                </v-row>
                <!--Reported message-->
                <v-row style="background-color:#DFDFDF;" class="ml-1 mr-1">
                  <v-col>
                    <p class="subtitle-1 font-weight-bold pr-2 text-center">Report Message</p>
                    <p class="subtitle-1">{{ item.moreDetails }}</p>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card class="pa-3" style="background-color: #eee" outlined>
                <p class="text-center title pb-3 pt-3" style="color: white; font-size: 1.2em; font-weight: 700; letter-spacing: .2em; text-shadow: 2px 2px 10px #000, 2px 2px 20px #000, -2px -2px 20px #000, 2px -2px 20px #000, -2px 2px 20px #000;">Info on the reported user</p>
                <!-- <pre>{{item}}</pre> -->
                <!--Id of the Reported user-->
                <v-row>
                  <!--Personal Information-->
                  <v-col>
                    <!--Full Name-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Full name:</span>
                      <span class="subtitle-1">{{ item.UserData.FullName }}</span>
                    </p>
                    <!--First Name-->
                    <!-- <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">First Name:</span>
                      <span class="subtitle-1">{{ item.UserData.FirstName }}</span>
                    </p> -->
                    <!--Last Name-->
                    <!-- <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Last Name:</span>
                      <span class="subtitle-1">{{ item.UserData.LastName }}</span>
                    </p> -->
                    <!--Nickname-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Nickname:</span>
                      <span class="subtitle-1">{{ item.UserData.Nickname }}</span>
                    </p>
                    <!--Email-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Email</span>
                      <span class="subtitle-1">{{ item.UserData.Email }}</span>
                      <!--If email are validated then display check, if not then a cross-->
                      <span class="subtitle-1 pl-3" v-if="item.UserData.EmailValidated == 1" title="Email validated">
                        <v-icon color="blue">fas fa-check</v-icon>
                      </span>
                      <span class="subtitle-1 pl-3" v-else title="Email NOT validated">
                        <v-icon color="error">fas fa-times</v-icon>
                      </span>
                    </p>
                    <!--Phone-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Phone:</span>
                      <span class="subtitle-1">{{ item.UserData.Phone }}</span>
                    </p>
                    <!--Account was created-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Account created:</span>
                      <span class="subtitle-1">{{ item.UserData.Created | moment('LL') }}</span>
                    </p>
                    <!--Address-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Address:</span>
                      <span class="subtitle-1">{{ item.UserData.Address }}</span>
                    </p>
                    <!--Postal Code-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Postal Code:</span>
                      <span class="subtitle-1">{{ item.UserData.PostalCode }}</span>
                    </p>
                    <!--City-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">City:</span>
                      <span class="subtitle-1">{{ item.UserData.City }}</span>
                    </p>
                    <!--Country-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Country:</span>
                      <span class="subtitle-1">{{ item.UserData.Country }}</span>
                    </p>
                    <!--Gender-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Gender:</span>
                      <span class="subtitle-1" v-if="item.UserData.Sex == 'M'">Male</span>
                      <span class="subtitle-1" v-else-if="item.UserData.Sex == 'F'">Female</span>
                      <span class="subtitle-1" v-else>Gender Unknown</span>
                    </p>
                  </v-col>
                  <!--Additional Information-->
                  <v-col>
                    <!--Id of the Reported user-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Reported user id:</span>
                      <span class="subtitle-1">{{ item.UserData.id }}</span>
                    </p>
                    <!--Role id - to see which role the user are-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Role id</span>
                      <span class="subtitle-1" v-if="item.UserData.RoleId == 1">
                        Admin
                        <v-icon class="pl-2" color="pink">fas fa-glasses</v-icon>
                      </span>
                      <span class="subtitle-1" v-else>No idea</span>
                    </p>
                    <!--about me section of the user-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">About Me:</span>
                      <span class="subtitle-1">{{ item.UserData.About }}</span>
                    </p>
                    <!--Last frontpage frontpage profile user was on / the frontpage profile user set as default-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">PrefererredProfile:</span>
                      <span class="subtitle-1">{{ item.UserData.PrefererredProfile }}</span>
                    </p>
                    <!--Language-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Set Language:</span>
                      <span class="subtitle-1">{{ item.UserData.Lang }}</span>
                    </p>
                    <!-- <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Media id - ?:</span>
                      <span class="subtitle-1">{{ item.UserData.Media_id }}</span>
                    </p> -->
                    <!--Status of the user: Active, Banned, so on-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Status:</span>
                      <span class="subtitle-1" v-if="item.UserData.Status == 1">
                        Active
                        <v-icon color="green" class="pl-2">far fa-smile</v-icon>
                      </span>
                      <span class="subtitle-1" v-else>
                        Banned? Other?
                        <v-icon color="yellow" class="pl-2">far fa-meh</v-icon>
                      </span>
                    </p>
                    <!--User are displaying Name-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">User display Name:</span>
                      <span class="subtitle-1" v-if="item.UserData.isName == 1">Yes</span>
                      <span class="subtitle-1" v-else>No</span>
                    </p>
                    <!--User are displaying Country-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">User display Country:</span>
                      <span class="subtitle-1" v-if="item.UserData.Country == 1">Yes</span>
                      <span class="subtitle-1" v-else>No</span>
                    </p>
                    <!--User are displaying Gender-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">User display Gender:</span>
                      <span class="subtitle-1" v-if="item.UserData.Gender == 1">Yes</span>
                      <span class="subtitle-1" v-else>No</span>
                    </p>
                    <!--Number of strikes the user have-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Number of strikes:</span>
                      <span class="subtitle-1">{{ item.UserData.NumStrikes }}</span>
                    </p>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <!--Information regarding the one reported-->
          <v-row>
            <v-col>
              <v-card class="pa-3" style="background-color: #eee" outlined>
                <p class="text-center title pb-3 pt-3" style="color: white; font-size: 1.2em; font-weight: 700; letter-spacing: .2em; text-shadow: 2px 2px 10px #000, 2px 2px 20px #000, -2px -2px 20px #000, 2px -2px 20px #000, -2px 2px 20px #000;">Info on user who made the report</p>
                <v-row>
                  <!--Personal Information-->
                  <v-col>
                    <!--Full Name-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Full Name:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.FullName }}</span>
                    </p>
                    <!--First Name-->
                    <!-- <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">First Name:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.FirstName }}</span>
                    </p> -->
                    <!--Last Name-->
                    <!-- <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Last Name:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.LastName }}</span>
                    </p> -->
                    <!--Nickname-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Nickname:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.Nickname }}</span>
                    </p>
                    <!--Email-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Email:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.Email }}</span>
                      <!--If email are validated then display check, if not then a cross-->
                      <span class="subtitle-1 pl-3" v-if="item.ReportedByUserData.EmailValidated == 1" title="Email validated">
                        <v-icon color="blue">fas fa-check</v-icon>
                      </span>
                      <span class="subtitle-1 pl-3" v-else title="Email NOT validated">
                        <v-icon color="error">fas fa-times</v-icon>
                      </span>
                    </p>
                    <!--Phone-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Phone:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.Phone }}</span>
                    </p>
                    <!--Account created-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Account created:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.Created | moment('LL') }}</span>
                    </p>
                    <!--Address-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Address:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.Address }}</span>
                    </p>
                    <!--Postal Code-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Postal Code:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.PostalCode }}</span>
                    </p>
                    <!--City-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">City:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.City }}</span>
                    </p>
                    <!--Country-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Country:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.Country }}</span>
                    </p>
                    <!--Gender-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Gender:</span>
                      <span class="subtitle-1" v-if="item.ReportedByUserData.Sex == 'M'">Male</span>
                      <span class="subtitle-1" v-else-if="item.ReportedByUserData.Sex == 'F'">Female</span>
                      <span class="subtitle-1" v-else>Gender Unknown</span>
                    </p>
                  </v-col>
                  <!--Additional Information-->
                  <v-col>
                    <!--User Id-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">User Id:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.id }}</span>
                    </p>
                    <!--Role id - to see which role the user are-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Role id</span>
                      <span class="subtitle-1" v-if="item.ReportedByUserData.RoleId == 1">
                        Admin
                        <v-icon class="pl-2" color="pink">fas fa-glasses</v-icon>
                      </span>
                      <span class="subtitle-1" v-else>No idea</span>
                    </p>
                    <!--About-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">About:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.About }}</span>
                    </p>
                    <!--Last frontpage frontpage profile user was on / the frontpage profile user set as default-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Prefered Profile:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.PrefererredProfile }}</span>
                    </p>
                    <!--Language-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Language:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.Lang }}</span>
                    </p>
                    <!--Media Id-->
                    <!-- <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Media Id ?:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.Media_id }}</span>
                    </p> -->
                    <!--Status of the user: Active, Banned, so on-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Status:</span>
                      <span class="subtitle-1" v-if="item.ReportedByUserData.Status == 1">
                        Active
                        <v-icon color="green" class="pl-2">far fa-smile</v-icon>
                      </span>
                      <span class="subtitle-1" v-else>
                        Banned? Other?
                        <v-icon color="yellow" class="pl-2">far fa-meh</v-icon>
                      </span>
                    </p>
                    <!--User are displaying Name-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">User display Name:</span>
                      <span class="subtitle-1" v-if="item.ReportedByUserData.isName == 1">Yes</span>
                      <span class="subtitle-1" v-else>No</span>
                    </p>
                    <!--User are displaying Country-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">User display Country:</span>
                      <span class="subtitle-1" v-if="item.ReportedByUserData.Country == 1">Yes</span>
                      <span class="subtitle-1" v-else>No</span>
                    </p>
                    <!--User are displaying Gender-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">User display Gender:</span>
                      <span class="subtitle-1" v-if="item.ReportedByUserData.Gender == 1">Yes</span>
                      <span class="subtitle-1" v-else>No</span>
                    </p>
                    <!--Strikes on the user-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Strikes on the user:</span>
                      <span class="subtitle-1">{{ item.ReportedByUserData.NumStrikes }}</span>
                    </p>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="auto">
          <v-card class="pa-3 mt-3" style="background-color: #eee" outlined>

          Article display
          <p>
            More features: See article itself that will be reported. (convenience) <br>
            2. Remove article, and send a notification to the users. <br>
              - User who reported: an action have been taken against the article/comment you have reported. <br>
              - The reported user: Your article/ comment, broke "X" in our ToS, and therefore have been removed. <br>
            3. Ban the reported user: If it is clear it is an grave direct violation of out ToS, like posting pron. <br>
            4. Give the reported user an notification and a warning?. <br>
            We the number, so can get the article data based on this. (Just need to figure out the call)
          </p>
          </v-card>
        </v-col>
      </v-row>
     
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data(){
    return {
      item: null,
      reportDataDialogArticle:false,
      // The report data within specific report
      reportData: [],
      // Dummy data below - named delete
      deleteHeadersAllReport:[
        { text: "Artikkel", value: "reportedArticle" },
        { text: "Av", value: "reportedBy" },
        { text: "Melding", value: "message" },
      ],
      deleteMeAllReport:[
        {id: 1, reportedArticle: "Ost er best", reportedBy: "Bob", message: "Popkorn er best!"},
        {id: 2, reportedArticle: "Visiting the palace", reportedBy: "Tåkelur", message: "Duplicate, he made this article 12 times already"},
        {id: 3, reportedArticle: "Kjøtt er best", reportedBy: "Bob", message:"Popkorn er best!!!"},
        {id: 4, reportedArticle: "ABC for skopuss", reportedBy: "Janne", message: "Er IKKE slik man pusser ein sko!"},
      ]
    }
  },
  methods:{
    openDialog(report){
      this.item = report;
      this.reportDataDialogArticle = true;
    },
    closeDialog(){
      this.reportDataDialogArticle = false;
    }
  }
}
</script>
